import SidePage from '../../../../../../shared/SidePage'
import SeparateLine from '../../../../../../shared/Forms/SeparateLine'
import useStateWithChange from '../../../../../../shared/hooks/useStateWithChange.ts'
import { TCreateMaintenanceProcessDTO } from '../../../maintenance.types.ts'
import maintenanceProcessesUtils from '../../maintenanceProcesses.utils.ts'
import formsUtils from '../../../../../../shared/Forms/forms.utils.ts'
import Button from '../../../../../../shared/Buttons/Button'
import useHttpLoader from '../../../../../../shared/hooks/useHttpLoader.ts'
import maintenanceApi from '../../../maintenance.api.ts'
import maintenanceEvents from '../../../events/maintenance.events.ts'
import MaintenanceProcessFormFields from '@/pages/Processes/Maintenance/MaintenanceProcesses/components/MaintenanceProcessFormFields'

interface IProps {
  onClose: () => void
  open: boolean
}

const CreateMaintenanceProcessSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [process, setProcess, handleChange] = useStateWithChange<TCreateMaintenanceProcessDTO>(
    maintenanceProcessesUtils.generateCreateProcessDTO()
  )

  const handleRuleUpdate = (index: number, value: any, key: string) => {
    setProcess((prev) => ({ ...prev, rules: formsUtils.arrays.updateItem(prev.rules, { [key]: value } as any, index) }))
  }

  const handleSave = () => {
    wait(
      maintenanceApi.createMaintenanceProcess({ ...process, rules: process.rules.filter((r) => r.blankSchemaId) }),
      (resp) => {
        if (resp.status === 'success') {
          maintenanceEvents.processCreated(resp.body)
          props.onClose()
        }
      }
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h2 className="text-heading-4">Создание модели ТО</h2>
        <SeparateLine />
        <MaintenanceProcessFormFields
          process={process}
          handleChange={handleChange}
          handleRuleUpdate={handleRuleUpdate}
        />
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateMaintenanceProcessSidePage
